<template>
    <div class="terms-wrapper">
        <app-header-mini :img="'/static/img/disclosure_policy/header.jpg'"></app-header-mini>
        <div class="terms-content">
            <h1 class="indent">Information disclosure policy</h1>
            <p class="indent">The information disclosure policy of <span class="strong">ALCOMET AD</span> is directly related to the needs of its investors and shareholders to obtain updated, adequate and sufficiently detailed and transparent information. The professional and ethical behaviour of the Company to all its partners puts it in the position of an attractive entity for investment directly affecting the interest in its shares in the securities market.</p>
            <p class="indent">The efficient information disclosure program promotes the achievement of the objectives set upon listing of the Company with BSE, i. e. better access to investments, improvement of products marketing and general positioning of the Company, attraction of a wider range of business contracting parties, suppliers and social partners for joint projects, facilitation of funds raising through issue of securities and proper capital market preparation, ensuring higher flexibility and shareholders’ assurance as to their investments, more efficient use of the professional players in the capital market to improve the liquidity of the securities issued by the Company and stronger media presence of the Company in specialized publications.</p>
            <p class="indent">The information disclosure program of <span class="strong">ALCOMET AD</span> includes financial and operating results of the Company, objectives of the Company, major shareholding interests and voting rights, members of the Management and Supervisory Boards, including executive directors and their functions,  material foreseeable risk factors, material issues related to the employees and other interested parties and corporate governance structure and policy.</p>
        </div>
    </div>
</template>

<script>
import HeaderMini from "./shared/HeaderMini";
export default {
  components: {
    appHeaderMini: HeaderMini
  }
};
</script>

<style scoped>
.terms-content {
  padding: 0 0 60px;
}
.terms-content > h1 {
  font-size: 34px;
  font-weight: 500;
  margin: 0 auto 25px;
  width: 800px;
}
.terms-content > p {
  font-size: 19px;
  text-align: justify;
  line-height: 32px;
  margin: 15px auto;
  width: 800px;
}
@media screen and (max-width: 1000px) {
  .terms-content > h1 {
    font-size: 20px;
    padding: 0 30px;
    width: 100%;
  }
  .terms-content > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DisclosurePolicy.vue